const main_prefix = "main";
export default function({ store, next, router }) {
    let url = window.location.href
    let prefix = new URL(url).host.split(".")[0]; 
    let remainder =  new URL(url).pathname
    if(prefix === 'edclearn' || prefix === 'www'){
        window.location.replace(`https://${main_prefix}.edclearn.com${remainder}`);
    }
  
    next();
}
